module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/奖杯组图.d1311db9.png";